export default {
    cn: {
        mt4ClosedTradesReport: {
            timeText: '平仓时间：',
            securityText: '产品组：',
            downloadName: 'MT5已平仓报表',
            cmdMapping: { 0: '买入', 1: '卖出' },
            loadText: '正在下载,请稍候...',
            tableHead: [
                { key: 'TICKET', value: '单号' },
                { key: 'LOGIN', value: '账号' },
                { key: 'NAME', value: '姓名' },
                { key: 'GROUP', value: '组别' },
                { key: 'CURRENCY', value: '入金货币' },
                { key: 'IB_ID', value: '代理账号' },
                { key: 'OFFICE_NAME', value: '所属办事处' },
                { key: 'OID', value: '办事处号码' },
                { key: 'ACC_NAME', value: '所属地区' },
                { key: 'RID', value: '地区编号' },
                { key: 'OPEN_TIME', value: '开仓时间' },
                { key: 'cmd', value: '交易类型' },
                { key: 'SYMBOL', value: '产品' },
                { key: 'SECURITY', value: '产品组' },
                { key: 'VOLUME', value: '手数' },
                { key: 'OPEN_PRICE', value: '开仓价' },
                { key: 'CLOSE_TIME', value: '平仓时间' },
                { key: 'CLOSE_PRICE', value: '平仓价' },
                { key: 'COMMISSION', value: '佣金' },
                { key: 'TAXES', value: '税费' },
                { key: 'COMMISSION_AGENT', value: '代理佣金' },
                { key: 'SWAPS', value: '利息' },
                { key: 'PROFIT', value: '盈亏' },
                { key: 'PIPES', value: '价位差' },
                { key: 'COMMENT', value: '注释' }
            ]
        }
    },
    hk: {
        mt4ClosedTradesReport: {
            timeText: '平倉時間：',
            securityText: '產品組：',
            downloadName: 'MT5已平倉報表',
            cmdMapping: { 0: '買入', 1: '賣出' },
            loadText: '正在下載,請稍候...',
            tableHead: [
                { key: 'TICKET', value: '單號' },
                { key: 'LOGIN', value: '賬號' },
                { key: 'NAME', value: '姓名' },
                { key: 'GROUP', value: '組別' },
                { key: 'CURRENCY', value: '入金貨幣' },
                { key: 'IB_ID', value: '代理賬號' },
                { key: 'OFFICE_NAME', value: '所屬辦事處' },
                { key: 'OID', value: '辦事處號碼' },
                { key: 'ACC_NAME', value: '所屬地區' },
                { key: 'RID', value: '地區編號' },
                { key: 'OPEN_TIME', value: '開倉時間' },
                { key: 'cmd', value: '交易類型' },
                { key: 'SYMBOL', value: '產品' },
                { key: 'SECURITY', value: '產品組' },
                { key: 'VOLUME', value: '手數' },
                { key: 'OPEN_PRICE', value: '開倉價' },
                { key: 'CLOSE_TIME', value: '平倉時間' },
                { key: 'CLOSE_PRICE', value: '平倉價' },
                { key: 'COMMISSION', value: '佣金' },
                { key: 'TAXES', value: '稅費' },
                { key: 'COMMISSION_AGENT', value: '代理佣金' },
                { key: 'SWAPS', value: '利息' },
                { key: 'PROFIT', value: '盈虧' },
                { key: 'PIPES', value: '價位差' },
                { key: 'COMMENT', value: '注釋' }
            ]
        }
    },
    en: {
        mt4ClosedTradesReport: {
            timeText: 'Close Time：',
            securityText: 'Securities：',
            downloadName: 'MT5 Closed Trades Report',
            cmdMapping: { 0: 'Buy', 1: 'Sell' },
            loadText: 'Downloading now,please wait a moment...',
            tableHead: [
                { key: 'TICKET', value: 'Deal' },
                { key: 'LOGIN', value: 'Login' },
                { key: 'NAME', value: 'Name' },
                { key: 'GROUP', value: 'Group' },
                { key: 'CURRENCY', value: 'Currency' },
                { key: 'IB_ID', value: 'IB Account' },
                { key: 'OFFICE_NAME', value: 'Office Name' },
                { key: 'OID', value: 'Office ID' },
                { key: 'ACC_NAME', value: 'Region Name' },
                { key: 'RID', value: 'Region ID' },
                { key: 'OPEN_TIME', value: 'Open Time' },
                { key: 'cmd', value: 'Type' },
                { key: 'SYMBOL', value: 'Symbol' },
                { key: 'SECURITY', value: 'Securities' },
                { key: 'VOLUME', value: 'Volume' },
                { key: 'OPEN_PRICE', value: 'Open Price' },
                { key: 'CLOSE_TIME', value: 'Close Time' },
                { key: 'CLOSE_PRICE', value: 'Close Price' },
                { key: 'COMMISSION', value: 'Commission' },
                { key: 'TAXES', value: 'Taxes' },
                { key: 'COMMISSION_AGENT', value: 'Agent' },
                { key: 'SWAPS', value: 'Swaps' },
                { key: 'PROFIT', value: 'Profit' },
                { key: 'PIPES', value: 'Pipes' },
                { key: 'COMMENT', value: 'Comment' }
            ]
        }
    }
}


// WEBPACK FOOTER //
// ./src/language/manager-report/mt4ClosedTradesReport.js